






























import { Vue } from "vue-property-decorator"
import type { url } from "@/@types/base"
import type { submit } from "@/@types/invest/invest_correct"
import TsUpload from "@/components/upload.vue";

export default Vue.extend({
  name      : "AddStadium",
  components: { TsUpload },
  props: {
    width  : { type: String, default: "800px" },
    correct: { type: Object, default() { return {} } },
  },
  data() {
    return {
      visible: false,
      loading: false,
      form   : {
        estimate_id: "",
        op         : 1,
        reason     : "",
        attach     : "",
      } as submit,
      empty_url: { path: "", url : "" } as url,
      images   : [
        { path: "", url : "" } as url
      ],
      rules : {
        reason: { required: true, message: "请填写纠错原因", trigger: "blur" },
        attach: { required: true, message: "请上传凭证", trigger: "blur" },
      },
    }
  },
  methods: {
    open(id: string, op: number) {
      this.$nextTick(() => {
        this.visible = true
        this.loading = false
        this.form.estimate_id = id
        this.form.op = op
      })
    },
    handleChange(path: string, index: number) {
      if (path == "") {
        const temp = this.$deep_copy(this.images)
        this.images = []
        for (const k in temp) {
          if (k != String(index)) {
            if (Object.prototype.hasOwnProperty.call(temp, k)) {
              this.images.push(temp[k])
            }
          }
        }
      } else this.images[index] = { path, url: this.$read_image(path) }
      const temp = []
      for (const img of this.images) if (img.path != "") temp.push(img.path)
      this.form.attach = temp.join(";")
      const form = this.$refs.form as any
      form.validate((valid: boolean) => { if (valid) form.clearValidate() })
      this.add_upload(this.images)
    },
    add_upload(urls: url[]) {
      let count = 0
      for (const v of urls) {
        if (v.path == "") count += 1
      }
      if (count == 0) {
        urls.push({ path: "", url: "" })
      }
    },
    async save() {
      if (Object.prototype.hasOwnProperty.call(this.correct, "business_time")) this.correct.business_time = this.correct.business_time.join(";")
      if (Object.prototype.hasOwnProperty.call(this.correct, "business_days_new")) this.correct.business_days_new = this.correct.business_days_new.join(";")
      if (Object.prototype.hasOwnProperty.call(this.correct, "prices") && this.correct.prices.length > 0) this.correct.prices = JSON.stringify(this.correct.prices)
      const res = await this.$store.dispatch("invest_correct/save", this.correct)
      if (res.Code == 200) {
        this.submit()
      } else this.$error({ content: res.Message })
    },
    /* async save_grounds(grounds: string) {
      const res = await this.$store.dispatch("invest_correct/save_ground", { estimate_id: this.form.estimate_id, op: this.form.op, grounds });
      if (res.Code == 200) this.submit()
      else this.$error({ content: res.Message })
    },
    async save_price(price: any[]) {
      for (const v of price) {
        const res = await this.$store.dispatch("invest_correct/add_price", { estimate_id: this.form.estimate_id, op: this.form.op, grounds });
        if (res.Code == 200) this.submit()
        else this.$error({ content: res.Message })
      }
    }, */
    async submit() {
      const result = await this.$store.dispatch("invest_correct/submit", this.form);
      if (result.Code == 200) {
        this.$info({
          title  : "提交成功！",
          content: "审核通过后，您所纠错的信息才能做相应的变更！",
          onOk   : () => {
            this.$emit("refresh")
            this.close()
          }
        })
      } else {
        this.$confirm({
          title : "提交失败，请重试！",
          okText: "重试",
          onOk  : () => this.submit(),
        })
      }
    },
    close() {
      const form = this.$refs.form as any
      form.resetFields()
      this.loading = false
      this.visible = false
    }
  }
})

